<template>
	<form @submit.prevent="" autocomplete="off">
		<div class="bg-brand-taupe-500 pb-10">
			<PageHeader :headingContent="headingContent" />
			<div class="pb-20 px-4">
				<Flash-Messages />
				<div class="container mx-auto md:flex">
					<div class=" md:w-2/3">
						<p><strong>Important:</strong>You must take reasonable care to make a fair presentation of your
							risk to
							AXA by providing accurate and complete answers to all questions. You should not provide any
							information
							that you know to be incorrect. </p>
					</div>
					<div v-if="this.review.status !== 'submitted'" class="flex md:w-1/3 md:justify-end justify-center mt-4">
						<div v-on:click="formSubmit('saveReview')" class="">
							<SaveReviewButton />
						</div>
						<SubmitReviewButton :disabled="!review.canBeSubmitted" @click="formSubmit('submitReview')" />
					</div>
					<div v-else class="flex md:w-1/3 md:justify-end justify-center mt-4">
						<Link class="" :href="`/reviews`">
						<button class="
							bg-brand-blue-400
							hover:bg-brand-blue-200
							text-white
							font-bold
							py-2
							px-4
							mr-2
							rounded
							uppercase
							text-sm
						" type="submit">
							Back to list of reviews
						</button>
						</Link>
					</div>
				</div>
				<ReviewForm :reviewTemplate="reviewTemplate" :review="review" :form="form" />
				<div class="container mx-auto md:flex">
					<div class=" md:w-2/3">
						<p>
							If you would like to speak to one of AXA’s dedicated Business Resilience team
							for further advice or support, please fill in some brief details on
							<Link href="/contact" class="underline text-brand-blue-200">the Contact page</Link>
							and someone will be in touch
						</p>
					</div>
					<div v-if="this.review.status !== 'submitted'" class="flex md:w-1/3 md:justify-end justify-center mt-4">
						<div v-on:click="formSubmit('saveReview')">
							<SaveReviewButton />
						</div>
						<SubmitReviewButton :disabled="!review.canBeSubmitted" @click="formSubmit('submitReview')" />
					</div>
					<div v-else class="flex md:w-1/3 md:justify-end justify-center mt-4">
						<Link :href="`/reviews`">
						<button class="
							bg-brand-blue-400
							hover:bg-brand-blue-200
							text-white
							font-bold
							py-2
							px-4
							mr-2
							rounded
							uppercase
							text-sm
						" type="submit">
							Back to list of reviews
						</button>
						</Link>
					</div>
				</div>
			</div>
		</div>
	</form>
</template>

<script>
import PageHeader from "../../Shared/PageHeader";
import FlashMessages from "../../Shared/FlashMessages";
import SaveReviewButton from "../../Shared/SaveReviewButton";
import SubmitReviewButton from "../../Shared/SubmitReviewButton";
import ReviewForm from "./Components/ReviewForm"
import PdfMixin from "./makePdf.mixin";

export default {
	mixins: [PdfMixin],
	components: {
		PageHeader,
		FlashMessages,
		SaveReviewButton,
		SubmitReviewButton,
		ReviewForm
	},
	props: {
		review: Object,
		reviewTemplate: Object,
		user: Object,
	},
	data: function () {
		return {
			form: this.$inertia.form({
				company: this.review.company,
				phone_number: this.review.phone_number,
				id: this.review.id,
				user_id: this.review.user_id,
				title: this.review.title,
				body: this.review.body,
				responses: this.review.responses,
				newResponses: [],
				userAction: null,
				pdf: "",
			}),
			headingContent: {
				hero: {
					image: '/images/159643845_trucks_hero.jpg',
					title: 'Fleet Risk Review',
					subtitle: 'In association with AXA Insurance',
				},
				page: {
					title: 'Edit Review',
					subtitle: '',
				},
			},
			hideReviewForm: false,
			
		}
	},
	methods: {
		formSubmit(userAction) {
			this.form.company = this.stripTags(this.form.company);
			this.form.phone_number = this.stripTags(this.form.phone_number);
			this.form.title = this.stripTags(this.form.title);
			this.form.body = this.stripTags(this.form.body);

			if (userAction === 'submitReview') {
				this.form.pdf = this.generatePdfBase64();
				// console.log(this.form.pdf);
				// debugger;
			}
			this.form.userAction = userAction;
			this.form.put('/reviews/' + this.review.id, '', {
				onSuccess: () => {
					this.hideReviewForm = userAction === "submitReview";
					this.headingContent.page.title = 'Review Submitted';
				},
				preserveScroll: true
			})
		},
		stripTags(originalString) {
			return originalString.replace(/(<([^>]+)>)/gi, "");
		}
	},
	mounted() {
		if (this.review.status === 'submitted') {
			this.headingContent.page.title = 'Viewing Submitted Review'
			this.headingContent.page.subtitle = 'Submitted: ' + this.$moment(this.review.submitted_at).format("DD MMM YYYY - HH:mm ")
		}
	}
}
</script>
